
// import { BLANK_PLACEHOLDER_IMG_URL } from '@marketplace/mixins/helpers.js'

export default {
    props: {
        listing: {
            type: Object,
            default: null,
        },
        storefront: {
            type: Object,
            default: null,
        },
        image: {
            type: String,
            default: null,
        },
    },
    computed: {
        src() {
            if (this.image) {
                return this.image
            }

            if (
                this.listing?.isReorderOnly &&
                ['REORDER_ONLY', 'PUBLISHED'].includes(this.storefront?.status)
            ) {
                return require(`~/assets/images/placeholders/reorder-only-product.avif`)
            }

            return require(`~/assets/images/placeholders/unavailable-product.avif`)
        },
    },
}
